// extracted by mini-css-extract-plugin
export var opacityBackground = "MobileSideNav-module--opacity-background--a80ba";
export var open = "MobileSideNav-module--open--bd8ab";
export var sideNav = "MobileSideNav-module--sideNav--539dd";
export var sideNavDismiss = "MobileSideNav-module--side-nav-dismiss--df463";
export var sideNavHeader = "MobileSideNav-module--side-nav-header--d332b";
export var sideNavLogo = "MobileSideNav-module--side-nav-logo--df03b";
export var sideNavWrapper = "MobileSideNav-module--side-nav-wrapper--cfbb1";